/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

 import _ from 'lodash';
 import Backbone from 'backbone';
 import Backgrid from 'backgrid';
 
 import HorizontalAddressDisplayView from '../HorizontalAddressDisplayView';
 
 const HorizontalAddressCell = Backgrid.Cell.extend({
   className: 'address-cell',
 
   render() {
     const cellValue = this.model.get(this.column.get('name'));
     let content = '--';
     if (cellValue && _.isObject(cellValue)) {
       const addressView = new HorizontalAddressDisplayView({
         model: new Backbone.Model(cellValue),
       });
       content = addressView.render().el;
     }
     this.$el.empty().append(content);
     this.$el.addClass(this.column.get('name'));
     this.delegateEvents();
     return this;
   },
 });
 
 export default HorizontalAddressCell;
 